module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"usersettings":"User settings","general":"General","tokens":"Tokens","provider":"Provider"},"fr":{"usersettings":"Préférences utilisateur","general":"Général","tokens":"Tokens","provider":"Fournisseur"}}')
  delete Component.options._Ctor
}
